// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n.container[data-v-352d3bff] {\n  background: #ffffff;\n  border-radius: 8px;\n  padding: 40px 30px;\n  margin-top: 40px;\n  box-shadow: 0 30px 20px -15px #e3e4eb;\n}\n.content[data-v-352d3bff] {\n  display: flex;\n  justify-content: center;\n}\n@media screen and (min-width: 500px) {\n.descriptions[data-v-352d3bff] {\n    min-width: 500px;\n}\n}", ""]);
// Exports
module.exports = exports;
